import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Navigate, useLocation } from 'react-router-dom';
import useGetRedirectPath from 'routing/useGetRedirectPath';

import { useAuthenticatedContext } from 'hooks/useAuthenticated';

import * as Styled from './Error404Page.styles';

const Error404Page = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const getRedirectPath = useGetRedirectPath();
  const location = useLocation();
  const { currentUser } = useAuthenticatedContext();

  return location.pathname === '/' ? (
    <Navigate to={getRedirectPath} />
  ) : (
    <Styled.Layout>
      <Styled.PageTitle data-cy="error404-title">{t('error404Page.pageNotFound')}</Styled.PageTitle>
      <Button
        data-cy="error404-backToHome"
        type="primary"
        onClick={() => navigate(getRedirectPath)}
      >
        {currentUser ? t('error404Page.backToHome') : t('error404Page.goToLoginPage')}
      </Button>
    </Styled.Layout>
  );
};

export default Error404Page;
